import { StyleSheet } from '@react-pdf/renderer';

import { PDF_STYLES_CONSTANTS } from './constants/pdfStylesConstants.ts';

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    bottom: PDF_STYLES_CONSTANTS.POSITIONS.FOOTER_BOTTOM,
    left: PDF_STYLES_CONSTANTS.DIMENSIONS.LEFT_MARGIN,
    width: PDF_STYLES_CONSTANTS.DIMENSIONS.CONTENT_WIDTH,
  },
  pageNumber: {
    fontSize: PDF_STYLES_CONSTANTS.FONT_SIZES.TINY,
  },
});

export default styles;
